<template>
  <div>
    <div class="columns is-desktop">
      <div class="column">
        <config-direct-match-general-properties
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <config-direct-match-cep-properties
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <config-direct-match-state-match
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
      </div>
      <div class="column">
        <config-direct-match-programs
          style="margin-bottom: 1rem"
          @allowEditOtherPanels="allowEditOtherPanels()"
          :editOtherPanels="editOtherPanels"
        />
        <quick-tips-direct-match-configuration/>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigDirectMatchGeneralProperties from '@/components/ConfigDirectMatchGeneralProperties.vue';
import ConfigDirectMatchCepProperties from '@/components/ConfigDirectMatchCepProperties.vue';
import ConfigDirectMatchStateMatch from '@/components/ConfigDirectMatchStateMatch.vue';
import ConfigDirectMatchPrograms from '@/components/ConfigDirectMatchPrograms.vue';
import QuickTipsDirectMatchConfiguration from '@/components/QuickTipsDirectMatchConfiguration.vue';
import NotificationManager from '@/mixins/NotificationManager';

export default {
  mixins: [
    NotificationManager,
  ],
  components: {
    ConfigDirectMatchGeneralProperties,
    ConfigDirectMatchCepProperties,
    ConfigDirectMatchStateMatch,
    ConfigDirectMatchPrograms,
    QuickTipsDirectMatchConfiguration,
  },
  data() {
    return {
      editOtherPanels: false,
    };
  },
  methods: {
    allowEditOtherPanels() {
      this.editOtherPanels = !this.editOtherPanels;
    },
  },
};
</script>

<style lang="sass" scoped>
  .column
    height: 100%
</style>
